// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__gZMgK","question":"Question_question__1ud7h","description":"Question_description__3PlY-"};